
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { AssigmentNotAcceptedGridDataService } from 'common/services/data-services/admin/assignment/assignment-not-accepted-grid-data.service';
import { AssignementNotAcceptedGridMetaModel } from 'common/models/page-models/Assignment Non Accepted Model/assignment-non-accepted-grid-meta.model';
import { AssignementNotAcceptingListingModel } from 'common/models/page-models/Assignment Non Accepted Model/assignment-non-accepted-params.model';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';

@Injectable({
    providedIn: 'root'
})
export class AssigmentNotAcceptedGridWidgetService extends GridWidgetService<AssignmentModel, AssignementNotAcceptingListingModel> {
    constructor(protected override ds: AssigmentNotAcceptedGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }

   
    getMetaModel(): MetaModel {
        const meta = new AssignementNotAcceptedGridMetaModel().getMetaModel();
        return meta;
    }


   


}

